/* Imports */
import React from "react"
import { Link } from "react-router-dom"
import { Font } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const ContainerPage = () => {
    const items = [
        {
            title: "Default main",
            content: (
                <Font.P>
                    <Link
                        to="/layouts/container/demo-main-default"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: "<Wrapper>\n    <Main>\n        \n    </Main>\n</Wrapper>",
        },
        {
            title: "Main large",
            content: (
                <Font.P>
                    <Link
                        to="/layouts/container/demo-main-large"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Wrapper>\n    <Main size="large">\n        \n    </Main>\n</Wrapper>',
        },
        {
            title: "Main form",
            content: (
                <Font.P>
                    <Link
                        to="/layouts/container/demo-main-form"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Wrapper>\n    <Main size="form">\n        \n    </Main>\n</Wrapper>',
        },
        {
            title: "Wrapper with aside on the left",
            content: (
                <Font.P>
                    <Link
                        to="/layouts/container/demo-aside-left"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Wrapper template="2cols">\n    <Aside position={1}>\n        \n    </Aside>\n\n    <Main position={2}>\n        \n    </Main>\n</Wrapper>',
        },
        {
            title: "Wrapper with aside on the right",
            content: (
                <Font.P>
                    <Link
                        to="/layouts/container/demo-aside-right"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Wrapper template="2cols">\n    <Main position={1}>\n\n    </Main>\n\n    <Aside position={2}>\n\n    </Aside>\n</Wrapper>',
        },
        {
            title: "Wrapper with aside on both sides",
            content: (
                <Font.P>
                    <Link
                        to="/layouts/container/demo-aside-both-sides"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Wrapper template="3cols">\n    <Aside position={1} size="small">\n        \n    </Aside>\n\n    <Main position={2}>\n\n    </Main>\n\n    <Aside position={3} size="small">\n\n    </Aside>\n</Wrapper>',
        },
    ]

    const propsItems = [
        {
            name: "template (Wrapper)",
            type: "String",
            example: "2cols",
            possible: '"1col" | "2cols" | "3cols"',
            default: "1col",
        },
        {
            name: "size (Main)",
            type: "String",
            example: "form",
            possible: '"default" | "large" | "form"',
            default: "default",
        },
        {
            name: "size (Aside)",
            type: "String",
            example: "small",
            possible: '"default" | "small"',
            default: "default",
        },
        {
            name: "position (Main)",
            type: "Number",
            example: "2",
            possible: "1 | 2",
            default: "1",
        },
        {
            name: "position (Aside)",
            type: "Number",
            example: "3",
            possible: "1 | 2 | 3",
            default: "1",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default ContainerPage
